export const LOCALE_SEPARATOR: string = "_";

export const DEFAULT_LOCALE = {
  locale: "en-GB",
  country: "GB",
  language: "en",
};

export const DOMAIN_TO_LOCALE: Map<string, string> = new Map<string, string>([
  ["at", "de_AT"],
  ["be", "nl_BE"],
  ["bg", "bg_BG"],
  ["ch", "fr_CH"],
  ["cy", "en_CY"],
  ["cz", "cs_CZ"],
  ["dk", "da_DK"],
  ["de", "de_DE"],
  ["ee", "et_EE"],
  ["es", "es_ES"],
  ["fi", "fi_FI"],
  ["fr", "fr_FR"],
  ["gb", "en_GB"],
  ["gr", "el_GR"],
  ["hr", "hr_HR"],
  ["hu", "hu_HU"],
  ["ie", "en_IE"],
  ["it", "it_IT"],
  ["lt", "lt_LT"],
  ["lu", "fr_LU"],
  ["lv", "lv_LV"],
  ["mt", "en_MT"],
  ["ni", "en_XI"],
  ["nl", "nl_NL"],
  ["pl", "pl_PL"],
  ["pt", "pt_PT"],
  ["ro", "ro_RO"],
  ["rs", "sr_RS"],
  ["se", "sv_SE"],
  ["si", "sl_SI"],
  ["sk", "sk_SK"],
  ["sv", "se_SV"],
  ["uk", "en_GB"],
  ["xi", "en_XI"],
  ['ba', 'bs_BA'],
  ['mk', 'mk_MK'],
]);

export const MAPPED_LOCALES: Map<string, [string, string]> = new Map<string, [string, string]>([
  ["bg_BG", ["bg", "BG"]],
  ["cs_CZ", ["cs", "CZ"]],
  ["da_DK", ["da", "DK"]],
  ["de_AT", ["de", "AT"]],
  ["de_CH", ["de", "CH"]],
  ["de_DE", ["de", "DE"]],
  ["el_CY", ["el", "CY"]],
  ["el_GR", ["el", "GR"]],
  ["en_CY", ["en", "CY"]],
  ["en_GB", ["en", "GB"]],
  ["en_IE", ["en", "IE"]],
  ["en_MT", ["en", "MT"]],
  ["en_XI", ["en", "XI"]],
  ["es_ES", ["es", "ES"]],
  ["et_EE", ["et", "EE"]],
  ["fi_FI", ["fi", "FI"]],
  ["fr_BE", ["fr", "BE"]],
  ["fr_CH", ["fr", "CH"]],
  ["fr_FR", ["fr", "FR"]],
  ["fr_LU", ["fr", "LU"]],
  ["hr_HR", ["hr", "HR"]],
  ["hu_HU", ["hu", "HU"]],
  ["it_CH", ["it", "CH"]],
  ["it_IT", ["it", "IT"]],
  ["lt_LT", ["lt", "LT"]],
  ["lv_LV", ["lv", "LV"]],
  ["nl_BE", ["nl", "BE"]],
  ["nl_NL", ["nl", "NL"]],
  ["pl_PL", ["pl", "PL"]],
  ["pt_PT", ["pt", "PT"]],
  ["ro_RO", ["ro", "RO"]],
  ["ru_EE", ["ru", "EE"]],
  ["ru_LV", ["ru", "LV"]],
  ["sk_SK", ["sk", "SK"]],
  ["sl_SI", ["sl", "SI"]],
  ["sr_RS", ["sr", "RS"]],
  ["sv_SE", ["sv", "SE"]],
  ['bs_BA', ['bs', 'BA']],
  ['sq_MK', ['sq', 'MK']],
  ['mk_MK', ['mk', 'MK']]
]);
